import React, { useMemo } from 'react';

import { Stack, Text } from '@eluve/components';

import type { BulkRowResult } from './useBulkUpdateDefaultBundle';

interface BulkResultSummaryProps {
  results: BulkRowResult[];
}

export const BulkResultSummary: React.FC<BulkResultSummaryProps> = ({
  results,
}) => {
  const { successes, failures } = useMemo(() => {
    const ok: BulkRowResult[] = [];
    const fail: BulkRowResult[] = [];
    for (const r of results) (r.ok ? ok : fail).push(r);
    return { successes: ok, failures: fail };
  }, [results]);

  if (results.length === 0) return null;

  return (
    <Stack gap={2}>
      <Stack direction="horizontal" gap={4}>
        <Text weight="semibold">
          Updated: <span>{successes.length}</span>
        </Text>
        <Text
          weight="semibold"
          className={failures.length > 0 ? 'text-text-warning-subtle' : ''}
        >
          Failed: <span>{failures.length}</span>
        </Text>
      </Stack>

      {failures.length > 0 && (
        <Stack
          gap={2}
          className="max-h-64 overflow-y-auto rounded-md border border-border-warning-subtle bg-bg-warning-subtle p-3"
        >
          <Text size="xs" weight="semibold">
            Failures
          </Text>
          <Stack gap={1}>
            {failures.map((f) => (
              <Stack key={f.user.userId} gap={0}>
                <Text inline>
                  {[f.user.firstName, f.user.lastName]
                    .filter(Boolean)
                    .join(' ') || '(no name)'}{' '}
                  <Text inline size="xs" color="supporting">
                    {f.user.email ?? ''}
                  </Text>
                </Text>
                <Text inline size="xs" color="supporting">
                  {f.error ?? 'Unknown error'}
                </Text>
              </Stack>
            ))}
          </Stack>
        </Stack>
      )}
    </Stack>
  );
};
